import type { ReactNode } from "react";

export type AlphabeticalSortOption = "az" | "za";

export type AllianceCountSortOption = "allianceAsc" | "allianceDesc";

export const alphabeticalSortOptions = [
  "az",
  "za",
] as const satisfies readonly AlphabeticalSortOption[];

export const allianceCountSortOptions = [
  "allianceAsc",
  "allianceDesc",
] as const satisfies readonly AllianceCountSortOption[];

export type FreelancerSortOptionKey =
  | AlphabeticalSortOption
  | AllianceCountSortOption;

export const DEFAULT_ALPHABETICAL_SORT: AlphabeticalSortOption = "az";

export const DEFAULT_ALLIANCE_COUNT_SORT: AllianceCountSortOption =
  "allianceDesc";

export type FreelancerSearchFilterBadgesLabels = {
  badgeLanguagePrefix: string;
  badgeServicePrefix: string;
  badgeCityPrefix: string;
  badgeRatingPrefix: string;
  badgeProximityPrefix: string;
  badgeAlphabeticalPrefix: string;
  badgeAllianceCountPrefix: string;
  sortAlphabeticalLabel: (option: AlphabeticalSortOption) => string;
  sortAllianceLabel: (option: AllianceCountSortOption) => string;
};

export type FreelancerSearchFilterToolbarLabels =
  FreelancerSearchFilterBadgesLabels & {
    filterBy: string;
    sortBy: string;
  };

export type ModalSlotRenderProps = {
  className: string;
  isBlocking: boolean;
  onClose: () => void;
  /** Applies search then closes this modal (desktop / mobile). */
  onSubmit: () => void;
};

export type ToolbarButtonProps = {
  className?: string;
  variant?: string;
  onClick?: () => void;
  children?: ReactNode;
};

export type ToolbarBadgeProps = {
  className?: string;
  variant?: string;
  color?: string;
  size?: string;
  endIcon?: ReactNode;
  children?: ReactNode;
};
